webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export fromName */
/* unused harmony export getName */
/* unused harmony export getDisplayName */
/* unused harmony export mapFromList */
function create(_ref) {
  var name = _ref.name,
      displayName = _ref.displayName;

  if (!displayName) {
    displayName = name;
  }
  return {
    name: name,
    displayName: displayName
  };
}

function fromName(name) {
  return create({ name: name });
}

function getName(category) {
  return category.name;
}

function getDisplayName(category) {
  return category.displayName;
}

function mapFromList(categories) {
  var categoriesMap = {};
  categories.forEach(function (c) {
    categoriesMap[c.name] = c;
  });
  return categoriesMap;
}

var ManipulationCategory = {
  mapFromList: mapFromList,
  create: create,
  fromName: fromName,
  getName: getName,
  getDisplayName: getDisplayName
};

/* harmony default export */ __webpack_exports__["a"] = (ManipulationCategory);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export getAnswerExplanationHTML */
/* unused harmony export getImageUrl */
/* unused harmony export getSourceName */
/* unused harmony export getSourceUrl */
/* unused harmony export getAnalysisName */
/* unused harmony export getAnalysisUrl */
/* unused harmony export isTrueNews */
/* unused harmony export isFalseNews */
/* unused harmony export isAnswered */
/* unused harmony export isAnsweredCorrectly */
/* unused harmony export isOmitted */
/* unused harmony export isOfManipulationCategory */
/* unused harmony export getManipulationCategoryName */
var create = function create(_ref) {
  var newsId = _ref.newsId,
      imageUrl = _ref.imageUrl,
      _ref$sourceName = _ref.sourceName,
      sourceName = _ref$sourceName === undefined ? '' : _ref$sourceName,
      _ref$sourceUrl = _ref.sourceUrl,
      sourceUrl = _ref$sourceUrl === undefined ? '' : _ref$sourceUrl,
      _ref$analysisName = _ref.analysisName,
      analysisName = _ref$analysisName === undefined ? '' : _ref$analysisName,
      _ref$analysisUrl = _ref.analysisUrl,
      analysisUrl = _ref$analysisUrl === undefined ? '' : _ref$analysisUrl,
      type = _ref.type,
      answerExplanationHTML = _ref.answerExplanationHTML,
      expectedAnswer = _ref.expectedAnswer;

  return {
    newsId: newsId,
    imageUrl: imageUrl,
    sourceName: sourceName,
    sourceUrl: sourceUrl,
    analysisName: analysisName,
    analysisUrl: analysisUrl,
    type: type,
    answer: null,
    answerExplanationHTML: answerExplanationHTML,
    expectedAnswer: expectedAnswer
  };
};

var getAnswerExplanationHTML = function getAnswerExplanationHTML(q) {
  return q.answerExplanationHTML;
};

var getImageUrl = function getImageUrl(q) {
  return q.imageUrl;
};

var getSourceName = function getSourceName(q) {
  return q.sourceName;
};

var getSourceUrl = function getSourceUrl(q) {
  return q.sourceUrl;
};

var getAnalysisName = function getAnalysisName(q) {
  return q.analysisName;
};

var getAnalysisUrl = function getAnalysisUrl(q) {
  return q.analysisUrl;
};

var isTrueNews = function isTrueNews(q) {
  return q.expectedAnswer === 'yes';
};

var isFalseNews = function isFalseNews(q) {
  return !isTrueNews(q);
};

var isAnswered = function isAnswered(q) {
  return !!q.answer;
};

var isAnsweredCorrectly = function isAnsweredCorrectly(q) {
  return q.answer === q.expectedAnswer;
};

var isOmitted = function isOmitted(q) {
  return !isAnswered(q);
};

function isOfManipulationCategory(question, manipulationCategory) {
  return question.type === manipulationCategory.name;
}

var getManipulationCategoryName = function getManipulationCategoryName(q) {
  return q.type;
};

var Question = {
  create: create,
  getAnswerExplanationHTML: getAnswerExplanationHTML,
  getImageUrl: getImageUrl,
  getSourceName: getSourceName,
  getSourceUrl: getSourceUrl,
  getAnalysisName: getAnalysisName,
  getAnalysisUrl: getAnalysisUrl,
  isTrueNews: isTrueNews,
  isFalseNews: isFalseNews,
  isAnswered: isAnswered,
  isAnsweredCorrectly: isAnsweredCorrectly,
  isOmitted: isOmitted,
  isOfManipulationCategory: isOfManipulationCategory,
  getManipulationCategoryName: getManipulationCategoryName
};

/* harmony default export */ __webpack_exports__["a"] = (Question);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QUESTION_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NUM_OF_QUIZ_QUESTIONS; });
/* unused harmony export ANSWERS_REVIEW_SCROLL_TOLERANCE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QUESTION_LANGUAGE; });
var QUESTION_TIMEOUT = 15 * 1000;
var NUM_OF_QUIZ_QUESTIONS = 16;
var ANSWERS_REVIEW_SCROLL_TOLERANCE = 40;
var QUESTION_LANGUAGE = 'pl';

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export encode */
/* unused harmony export decode */
/* unused harmony export getUserName */
/* unused harmony export getCorrectnessEstimate */
/* unused harmony export getByManipulationCategory */
/* unused harmony export getNumOfAnswers */
/* unused harmony export getNumOfCorrectAnswers */
/* unused harmony export getNumOfOmittedAnswers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_collections__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__manipulation_category__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__quiz_setup_info__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user__ = __webpack_require__(51);







function create(_ref) {
  var quiz = _ref.quiz,
      user = _ref.user,
      quizSetupInfo = _ref.quizSetupInfo,
      manipulationCategories = _ref.manipulationCategories;

  var results = {
    version: 'v1',
    username: __WEBPACK_IMPORTED_MODULE_5__user__["a" /* default */].getName(user),
    est: __WEBPACK_IMPORTED_MODULE_4__quiz_setup_info__["a" /* default */].getCorrectnessEstimate(quizSetupInfo),
    total: quiz.questions.length,
    correct: countQuestionsByPredicate(quiz, __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isAnsweredCorrectly),
    omitted: countQuestionsByPredicate(quiz, __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isOmitted),
    byManipCat: {}
  };
  manipulationCategories.forEach(function (category) {
    var name = __WEBPACK_IMPORTED_MODULE_2__manipulation_category__["a" /* default */].getName(category);
    var isOfManipulationCategory = function isOfManipulationCategory(q) {
      return __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isOfManipulationCategory(q, category);
    };
    var total = countQuestionsByPredicate(quiz, isOfManipulationCategory);
    var correct = countQuestionsByPredicate(quiz, function (q) {
      return isOfManipulationCategory(q) && __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isAnsweredCorrectly(q);
    });
    var omitted = countQuestionsByPredicate(quiz, function (q) {
      return isOfManipulationCategory(q) && __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isOmitted(q);
    });
    results.byManipCat[name] = {
      total: total,
      correct: correct,
      omitted: omitted
    };
  });
  return results;
}

function encode(resultStats) {
  var resultsStatsJSON = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resultStats);
  var resultsStatsPayload = btoa(resultsStatsJSON);
  return resultsStatsPayload;
}

function decode(resultStatsPayload) {
  var resultStatsJSON = atob(resultStatsPayload);
  var resultStats = JSON.parse(resultStatsJSON);
  return resultStats;
}

function getUserName(resultStats) {
  return resultStats.username;
}

function getCorrectnessEstimate(resultStats) {
  return resultStats.est;
}

function getByManipulationCategory(resultStats, manipulationCategory) {
  return resultStats.byManipCat[manipulationCategory.name];
}

function getNumOfAnswers(stats) {
  return stats.total;
}

function getNumOfCorrectAnswers(stats) {
  return stats.correct;
}

function getNumOfOmittedAnswers(stats) {
  return stats.omitted;
}

function countQuestionsByPredicate(quiz, predicate) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_collections__["a" /* countByPredicate */])(quiz.questions, predicate);
}

var ResultStats = {
  create: create,
  encode: encode,
  decode: decode,
  getUserName: getUserName,
  getCorrectnessEstimate: getCorrectnessEstimate,
  getByManipulationCategory: getByManipulationCategory,
  getNumOfAnswers: getNumOfAnswers,
  getNumOfCorrectAnswers: getNumOfCorrectAnswers,
  getNumOfOmittedAnswers: getNumOfOmittedAnswers
};

/* harmony default export */ __webpack_exports__["a"] = (ResultStats);

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  mounted: function mounted() {
    // test for touch events support and if not supported, attach .no-touch class to the HTML tag.
    if (!('ontouchstart' in document.documentElement)) {
      document.documentElement.className += ' no-touch';
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_location__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Intro',
  data: function data() {
    return {
      page: 1,
      userInfo: {
        name: '',
        prediction: 50,
        category: ''
      },
      validationError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isQuizLoaded']), {
    pageTransitions: function pageTransitions() {
      return {
        6: {
          canGoNext: function canGoNext() {
            return this.userInfo.category !== '';
          },
          next: function next() {
            this.setUserInfo(this.userInfo);
            this.generateQuiz();
          }
        },
        8: {
          canGoNext: function canGoNext() {
            return this.isQuizLoaded;
          },
          next: function next() {
            this.startQuiz();
          }
        }
      };
    },
    incrementPageEnabled: function incrementPageEnabled() {
      var pageTransition = this.pageTransitions[this.page];
      if (pageTransition && pageTransition.canGoNext) {
        return pageTransition.canGoNext.call(this);
      }
      return true;
    },
    incrementPageDisabled: function incrementPageDisabled() {
      return !this.incrementPageEnabled;
    },
    incrementPageButtonText: function incrementPageButtonText() {
      if (this.page === 1) {
        return 'OK, pokażcie wskazówki';
      }
      if (this.page === 8) {
        if (this.isQuizLoaded) {
          return 'tak, zaczynamy!';
        } else {
          return 'czekaj...';
        }
      }
      return 'dalej';
    },
    incrementPageButtonClass: function incrementPageButtonClass() {
      if (this.page === 8) {
        return 'blue';
      }
      return 'opaque-blue';
    },
    questionTimeoutInSeconds: function questionTimeoutInSeconds() {
      return __WEBPACK_IMPORTED_MODULE_3__consts__["c" /* QUESTION_TIMEOUT */] / 1000;
    },
    numOfQuizQuestions: function numOfQuizQuestions() {
      return Object({"NODE_ENV":"production","BUILD_ENV":"production","GOOGLE_ANALYTICS_TRACKER_ID":"UA-156092120-1","BACKEND_HOST":"backend.fakesnothanks.pl","BACKEND_HTTP_SCHEME":"https","APP_HOST":"aplikacja.fajniezewiesz.pl","APP_HTTP_SCHEME":"https"}).NUM_OF_QUIZ_QUESTIONS || __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* NUM_OF_QUIZ_QUESTIONS */];
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.pingBackend();
    this.fetchManipulationCategories().then(function () {
      var queryParams = Object(__WEBPACK_IMPORTED_MODULE_2__utils_location__["a" /* parseQuery */])(window.location.search);
      if (queryParams.results) {
        _this.$router.replace({
          name: 'Results',
          params: queryParams
        });
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['generateQuiz', 'pingBackend', 'fetchManipulationCategories']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['setUserInfo']), {
    incrementPage: function incrementPage() {
      var pageTransition = this.pageTransitions[this.page];
      ++this.page;
      if (this.page === 7 && !['ue', 'ue2', 'climate', 'health', 'society'].includes(this.userInfo.category)) {
        ++this.page;
      }
      if (pageTransition && pageTransition.next) {
        pageTransition.next.call(this);
      }
    },
    startQuiz: function startQuiz() {
      localStorage.setItem('category', this.userInfo.category);
      this.$router.push('/quiz');
    }
  })
});

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PieChart__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_QuestCard__ = __webpack_require__(47);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Quest',
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_3__components_PieChart__["a" /* default */],
    QuestCard: __WEBPACK_IMPORTED_MODULE_4__components_QuestCard__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    document.body.classList.add('dark');
    next(function (vm) {
      vm.startQuestionTimeout();
      vm.startTicker();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.stopQuestionTimeout();
    this.stopTicker();
    next();
  },

  data: function data() {
    return {
      tick: Date.now(),
      buttonsDisabled: false
    };
  },
  computed: {
    question: function question() {
      return this.$store.getters.currentQuizQuestion;
    },
    questions: function questions() {
      return this.$store.getters.quizQuestions;
    },
    questionIndex: function questionIndex() {
      return this.$store.getters.quizQuestionIndex;
    },
    questionNumber: function questionNumber() {
      return this.$store.getters.quizQuestionIndex + 1;
    },
    countdownSeconds: function countdownSeconds() {
      var delta = this.tick - this.questionStartTime;
      return Math.ceil((__WEBPACK_IMPORTED_MODULE_2__consts__["c" /* QUESTION_TIMEOUT */] - delta) / 1000);
    },
    questionTimeoutSeconds: function questionTimeoutSeconds() {
      return __WEBPACK_IMPORTED_MODULE_2__consts__["c" /* QUESTION_TIMEOUT */] / 1000;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['answerQuizQuestion', 'omitQuizQuestion']), {
    disableButtons: function disableButtons() {
      this.buttonsDisabled = true;
    },
    enableButtons: function enableButtons() {
      this.buttonsDisabled = false;
    },
    answerTrueNews: function answerTrueNews() {
      this.answer('yes');
    },
    answerFalseNews: function answerFalseNews() {
      this.answer('no');
    },
    answer: function answer(a) {
      this.answerQuestionOrEndQuiz(a);
    },
    afterEnter: function afterEnter() {
      this.enableButtons();
    },
    leave: function leave() {
      this.disableButtons();
    },
    answerQuestionOrEndQuiz: function answerQuestionOrEndQuiz(answer) {
      this.stopQuestionTimeout();
      this.answerQuizQuestion({
        answer: answer
      });
      this.disableButtons();
      if (this.$store.getters.isQuizFinished) {
        this.goToResults();
      } else {
        this.startQuestionTimeout();
      }
    },
    omitQuestionOrEndQuiz: function omitQuestionOrEndQuiz() {
      this.omitQuizQuestion();
      if (this.$store.getters.isQuizFinished) {
        this.goToResults();
      } else {
        this.startQuestionTimeout();
      }
    },
    goToResults: function goToResults() {
      this.$router.push('/results');
    },
    stopQuestionTimeout: function stopQuestionTimeout() {
      clearTimeout(this.questionTimeout);
    },
    startQuestionTimeout: function startQuestionTimeout() {
      var _this = this;

      clearTimeout(this.questionTimeout);
      this.questionStartTime = Date.now();
      this.questionTimeout = setTimeout(function () {
        _this.omitQuestionOrEndQuiz();
      }, __WEBPACK_IMPORTED_MODULE_2__consts__["c" /* QUESTION_TIMEOUT */]);
    },
    startTicker: function startTicker() {
      var _this2 = this;

      this.tickInterval = setInterval(function () {
        _this2.tick = Date.now();
      }, 100);
    },
    stopTicker: function stopTicker() {
      clearInterval(this.tickInterval);
    }
  })
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PieChart',
  props: {
    numerator: {
      type: Number,
      required: true
    },
    denominator: {
      type: Number,
      required: true
    },
    textPercent: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      r: 100 / this.denominator,
      total: 100
    };
  },

  computed: {
    score: function score() {
      return this.numerator * this.r;
    },
    percent: function percent() {
      return Math.floor(this.numerator / this.denominator * 100);
    },
    counterText: function counterText() {
      if (this.textPercent && this.denominator > 0) {
        return this.percent + '%';
      } else if (!this.textPercent) {
        return this.numerator;
      } else {
        return 'N/A';
      }
    },
    points: function points() {
      var points = { s: '', t: '' };
      var x = void 0,
          y = void 0,
          angle = void 0;
      for (var i = 0; i < this.total + 1; i++) {
        angle = Math.PI * 2 / this.total * i;
        x = 25 + 20 * Math.cos(angle + Math.PI / 2);
        y = 25 + 20 * -Math.sin(angle + Math.PI / 2);
        points.t += x + ',' + y + ' ';
        if (this.score >= i) {
          points.s = points.t;
        }
      }
      return points;
    }
  },
  created: function created() {}
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestCard_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be372f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestCard_vue__ = __webpack_require__(110);
function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be372f0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be372f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QuestCard',
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  computed: {
    answerClass: function answerClass() {
      if (this.question.answer === 'yes') {
        return 'answer-true';
      } else if (this.question.answer === 'no') {
        return 'answer-false';
      }
      return null;
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_result_stats__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Results',
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    document.body.classList.add('dark');
    next();
  },
  data: function data() {
    return {
      emo: false,
      bait: false,
      lie: false,
      manipulation: false
    };
  },

  computed: {
    resultStats: function resultStats() {
      var routeResultStatsPayload = this.$route.params.results;
      if (routeResultStatsPayload) {
        // load results from url
        return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].decode(routeResultStatsPayload);
      } else {
        return this.$store.getters.resultStats;
      }
    },
    resultStatsEmoLang: function resultStatsEmoLang() {
      return this.getManipulationCategoryResultStats('emotional-language');
    },
    resultStatsClickbait: function resultStatsClickbait() {
      return this.getManipulationCategoryResultStats('clickbait');
    },
    resultStatsFakeNews: function resultStatsFakeNews() {
      return this.getManipulationCategoryResultStats('fake-news');
    },
    resultStatsImgManip: function resultStatsImgManip() {
      return this.getManipulationCategoryResultStats('image-manipulation');
    },
    correctnessBetterThanEstimated: function correctnessBetterThanEstimated() {
      return this.correctness > this.correctnessEstimate;
    },
    correctnessWorseThanEstimated: function correctnessWorseThanEstimated() {
      return this.correctness < this.correctnessEstimate;
    },
    correctnessPercent: function correctnessPercent() {
      return Math.floor(this.numOfCorrectAnswers / this.numOfQuestions * 100);
    },
    correctnessEstimatePercent: function correctnessEstimatePercent() {
      return Math.floor(this.correctnessEstimate * 100);
    },
    correctness: function correctness() {
      return this.numOfCorrectAnswers / this.numOfQuestions;
    },
    correctnessEstimate: function correctnessEstimate() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getCorrectnessEstimate(this.resultStats);
    },
    numOfQuestions: function numOfQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStats);
    },
    numOfCorrectAnswers: function numOfCorrectAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStats);
    },
    numOfEmotionalLanguageQuestions: function numOfEmotionalLanguageQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStatsEmoLang);
    },
    numOfCorrectEmotionalLanguageAnswers: function numOfCorrectEmotionalLanguageAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStatsEmoLang);
    },
    numOfClickbaitQuestions: function numOfClickbaitQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStatsClickbait);
    },
    numOfCorrectClickbaitAnswers: function numOfCorrectClickbaitAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStatsClickbait);
    },
    numOfFakeNewsQuestions: function numOfFakeNewsQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStatsFakeNews);
    },
    numOfCorrectFakeNewsAnswers: function numOfCorrectFakeNewsAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStatsFakeNews);
    },
    numOfImageManipulationQuestions: function numOfImageManipulationQuestions() {
      return this.resultStatsImgManip.total;
    },
    numOfCorrectImageManipulationAnswers: function numOfCorrectImageManipulationAnswers() {
      return this.resultStatsImgManip.correct;
    },
    username: function username() {
      return this.resultStats.username;
    },
    title: function title() {
      return this.titleAndDescription[0];
    },
    description: function description() {
      return this.titleAndDescription[1];
    },
    titleAndDescription: function titleAndDescription() {
      var ratio = this.numOfCorrectAnswers / this.numOfQuestions;

      if (ratio >= 16 / 16) {
        return ['Rewelacyjnie Ci poszło!', 'Mistrzowsko odróżniasz prawdziwe informacje od fałszywych.'];
      } else if (ratio >= 12 / 16) {
        return ['Dobrze Ci poszło!', 'Jeszcze trochę i mistrzowsko będziesz rozpoznawał fake newsy!'];
      } else if (ratio >= 9 / 16) {
        return ['Nieźle Ci poszło', 'Nie zawsze potrafisz odróżnić fake newsy od prawdy. Potrenuj i zagraj jeszcze raz!'];
      } else if (ratio >= 5 / 16) {
        return ['Mogło być lepiej', 'Wiesz, czym są fake newsy, jednak musisz popracować nad ich rozpoznawaniem.' + ' Sprawdź swoje odpowiedzi i spróbuj zagrać jeszcze raz.'];
      }
      return ['Czas na lekcję krytycznego myślenia', 'Niestety nie poszło Ci dobrze, sprawdź swoje odpowiedzi i zwróć uwagę na wyjaśnienia.' + ' Zagraj jeszcze raz i popraw swój wynik.'];
    }
  },
  methods: {
    getManipulationCategoryResultStats: function getManipulationCategoryResultStats(categoryName) {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getByManipulationCategory(this.resultStats, __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].fromName(categoryName));
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export getCorrectnessEstimate */
/* unused harmony export getTopicCategory */
/* unused harmony export setValues */
function create(_ref) {
  var _ref$topicCategory = _ref.topicCategory,
      topicCategory = _ref$topicCategory === undefined ? null : _ref$topicCategory,
      _ref$correctnessEstim = _ref.correctnessEstimate,
      correctnessEstimate = _ref$correctnessEstim === undefined ? 1.0 : _ref$correctnessEstim;

  return {
    topicCategory: topicCategory,
    correctnessEstimate: correctnessEstimate
  };
}

function getCorrectnessEstimate(quizSetupInfo) {
  return quizSetupInfo.correctnessEstimate;
}

function getTopicCategory(quizSetupInfo) {
  return quizSetupInfo.topicCategory;
}

function setValues(quizSetupInfo, _ref2) {
  var topicCategory = _ref2.topicCategory,
      correctnessEstimate = _ref2.correctnessEstimate;

  if (typeof topicCategory !== 'undefined') {
    quizSetupInfo.topicCategory = topicCategory;
  }
  if (typeof correctnessEstimate !== 'undefined') {
    quizSetupInfo.correctnessEstimate = correctnessEstimate;
  }
}

var QuizSetupInfo = {
  create: create,
  getCorrectnessEstimate: getCorrectnessEstimate,
  getTopicCategory: getTopicCategory,
  setValues: setValues
};

/* harmony default export */ __webpack_exports__["a"] = (QuizSetupInfo);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export getName */
/* unused harmony export setName */
function create(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === undefined ? 'test' : _ref$name;

  return {
    name: name
  };
}

function getName(user) {
  return user.name;
}

function setName(user, name) {
  user.name = name;
}

var User = {
  create: create,
  getName: getName,
  setName: setName
};

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_QuestCard__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FootLinkNote__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_question__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AnswersReview',
  components: {
    QuestCard: __WEBPACK_IMPORTED_MODULE_0__components_QuestCard__["a" /* default */],
    FootLinkNote: __WEBPACK_IMPORTED_MODULE_1__components_FootLinkNote__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    document.body.classList.remove('dark');
    next();
  },
  data: function data() {
    return {
      questionIndex: 0,
      scrollOffset: 0,
      maxScrollOffset: 0,
      answerTypesDict: {
        'nothing': {
          className: 'no-answer',
          text: 'nie odpowiedziałeś',
          icon: '☹', // https://www.utf8icons.com/character/9785/white-frowning-face
          iconClassName: 'no-answer'
        },
        'correct': {
          className: 'correct-answer',
          text: 'Dobra odpowiedź!',
          icon: '✓',
          iconClassName: 'circle-icon correct-answer-circle'
        },
        'wrong': {
          className: 'wrong-answer',
          text: 'Zła odpowiedź!',
          icon: '×',
          iconClassName: 'circle-icon wrong-answer-circle'
        }
      }
    };
  },

  computed: {
    nextAnswerEnabled: function nextAnswerEnabled() {
      return true;
    },
    nextAnswerText: function nextAnswerText() {
      if (this.nextAnswerEnabled) {
        return 'następny';
      } else {
        return 'scrolluj w dół';
      }
    },
    newsIsTrue: function newsIsTrue() {
      if (this.question.expectedAnswer === 'yes') {
        return true;
      } else if (this.question.expectedAnswer === 'no') {
        return false;
      }
      return null;
    },
    answerExplanationHTML: function answerExplanationHTML() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getAnswerExplanationHTML(this.question);
    },
    answerType: function answerType() {
      var answerTypeString = void 0;
      if (!__WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].isAnswered(this.question)) {
        answerTypeString = 'nothing';
      } else if (__WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].isAnsweredCorrectly(this.question)) {
        answerTypeString = 'correct';
      } else {
        answerTypeString = 'wrong';
      }
      return this.answerTypesDict[answerTypeString];
    },
    sourceUrl: function sourceUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getSourceUrl(this.question);
    },
    sourceName: function sourceName() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getSourceName(this.question);
    },
    analysisUrl: function analysisUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getAnalysisUrl(this.question);
    },
    analysisName: function analysisName() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getAnalysisName(this.question);
    },
    question: function question() {
      return this.questions[this.questionIndex];
    },
    questions: function questions() {
      return this.$store.getters.quizQuestions;
    }
  },
  mounted: function mounted() {
    this.updateScrollData();
  },

  methods: {
    calculateScrollData: function calculateScrollData() {
      var container = this.$refs.container;
      if (!container) {
        return { scrollOffset: 0, maxScrollOffset: 0 };
      }
      var containerHeight = container.getBoundingClientRect().height;
      var scrollOffset = container.scrollTop - container.offsetTop;
      var maxScrollOffset = container.scrollHeight - containerHeight;
      return { scrollOffset: scrollOffset, maxScrollOffset: maxScrollOffset };
    },
    updateScrollData: function updateScrollData() {
      var _calculateScrollData = this.calculateScrollData(),
          scrollOffset = _calculateScrollData.scrollOffset,
          maxScrollOffset = _calculateScrollData.maxScrollOffset;

      this.scrollOffset = scrollOffset;
      this.maxScrollOffset = maxScrollOffset;
    },
    scrollToTop: function scrollToTop() {
      var container = this.$refs.container;
      if (!container) {
        return;
      }
      container.scrollTo(0, 0);
    },
    goToNextAnswer: function goToNextAnswer() {
      var _this = this;

      this.questionIndex += 1;
      if (this.questionIndex >= this.$store.getters.numOfQuizQuestions) {
        this.goToSummary();
      } else {
        this.scrollToTop();
        this.$nextTick(function () {
          // Update scrollData when changes are propagated to DOM just in case.
          _this.updateScrollData();
        });
      }
    },
    goToSummary: function goToSummary() {
      var path = '/summary';
      if (window.localStorage.getItem('category') === 'vaccinations') {
        path = '/unicef';
      } else if (window.localStorage.getItem('category') === 'ue2') {
        path = '/eu';
      }

      this.$router.push(path);
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FootLinkNote',
  props: {
    name: {
      type: String,
      required: true
    },
    linkName: {
      type: String,
      required: true,
      default: ''
    },
    linkUrl: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    linkNameText: function linkNameText() {
      if (!this.linkName && this.linkUrl) {
        return 'link';
      }
      return this.linkName;
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary'
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SummaryUnicef'
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SummaryEU'
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_result_stats__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShareResults',
  data: function data() {
    return {
      rated: false
    };
  },
  computed: {
    resultStats: function resultStats() {
      return this.$store.getters.resultStats;
    },
    resultsUrl: function resultsUrl() {
      var _window$location = window.location,
          protocol = _window$location.protocol,
          host = _window$location.host;


      var statsPayload = __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].encode(this.resultStats);
      var url = protocol + '//' + host + '/?results=' + statsPayload;
      return url;
    },
    appUrl: function appUrl() {
      var _window$location2 = window.location,
          protocol = _window$location2.protocol,
          host = _window$location2.host;


      var url = protocol + '//' + host + '/';
      return url;
    },
    correctnessPercent: function correctnessPercent() {
      return Math.floor(this.numOfCorrectAnswers / this.numOfQuestions * 100);
    },
    numOfQuestions: function numOfQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStats);
    },
    numOfCorrectAnswers: function numOfCorrectAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStats);
    }
  },
  methods: {
    shareResults: function shareResults() {
      var url = this.appUrl;
      var fbShareUrl = 'http://www.facebook.com/sharer.php?u=' + encodeURIComponent(url);
      window.open(fbShareUrl, 'sharer', 'toolbar=0,status=0,width=626,height=436');
    },
    sendRate: function sendRate() {
      var rate = document.querySelector('input[name="rating"]:checked').value;
      // eslint-disable-next-line no-undef
      gtag('event', 'rate_app', {
        'event_category': 'feedback',
        'event_label': 'fzw-webapp',
        'value': rate
      });
      this.rated = true;
    }
  }
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(69);


var _process$env = Object({"NODE_ENV":"production","BUILD_ENV":"production","GOOGLE_ANALYTICS_TRACKER_ID":"UA-156092120-1","BACKEND_HOST":"backend.fakesnothanks.pl","BACKEND_HTTP_SCHEME":"https","APP_HOST":"aplikacja.fajniezewiesz.pl","APP_HTTP_SCHEME":"https"}),
    BACKEND_HTTP_SCHEME = _process$env.BACKEND_HTTP_SCHEME,
    BACKEND_HOST = _process$env.BACKEND_HOST;

var API_BASE_URL = BACKEND_HTTP_SCHEME + '://' + BACKEND_HOST + '/api/v1/';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].create({
  baseURL: API_BASE_URL
}));

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios);

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export getId */
/* unused harmony export getCurrentQuestion */
/* unused harmony export getQuestions */
/* unused harmony export getQuestionIndex */
/* unused harmony export isFinished */
/* unused harmony export answerQuestion */
/* unused harmony export omitQuestion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__question__ = __webpack_require__(18);


function create(_ref) {
  var id = _ref.id,
      _ref$questions = _ref.questions,
      questions = _ref$questions === undefined ? [] : _ref$questions;

  return {
    id: id,
    questionIndex: 0,
    questions: questions.map(__WEBPACK_IMPORTED_MODULE_0__question__["a" /* default */].create)
  };
}

function getId(quiz) {
  return quiz.id;
}

function getCurrentQuestion(quiz) {
  return quiz.questions[quiz.questionIndex];
}

function getQuestions(quiz) {
  return quiz.questions;
}

function getQuestionIndex(quiz) {
  return quiz.questionIndex;
}

function isFinished(quiz) {
  return quiz.questionIndex >= quiz.questions.length;
}

function answerQuestion(quiz, answer) {
  if (isFinished(quiz)) {
    return;
  }
  quiz.questions[quiz.questionIndex].answer = answer;
  quiz.questionIndex++;
}

function omitQuestion(quiz) {
  if (isFinished(quiz)) {
    return;
  }
  quiz.questionIndex++;
}

var Quiz = {
  create: create,
  getId: getId,
  getCurrentQuestion: getCurrentQuestion,
  getQuestions: getQuestions,
  getQuestionIndex: getQuestionIndex,
  isFinished: isFinished,
  answerQuestion: answerQuestion,
  omitQuestion: omitQuestion
};

/* harmony default export */ __webpack_exports__["a"] = (Quiz);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export fromName */
/* unused harmony export getName */
/* unused harmony export getDisplayName */
function create(_ref) {
  var name = _ref.name,
      displayName = _ref.displayName;

  if (!displayName) {
    displayName = name;
  }
  return {
    name: name,
    displayName: displayName
  };
}

function fromName(name) {
  return create({ name: name });
}

function getName(category) {
  return category.name;
}

function getDisplayName(category) {
  return category.displayName;
}

var TopicCategory = {
  create: create,
  fromName: fromName,
  getName: getName,
  getDisplayName: getDisplayName
};

/* harmony default export */ __webpack_exports__["a"] = (TopicCategory);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__(69);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

// In abstract router mode we must set the initial location explicitly:
/// https://github.com/vuejs/vue-router/issues/729
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/');

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0b7adf4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(86);
function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0b7adf4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Intro__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Quest__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Results__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AnswersReview__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Summary__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SummaryUnicef__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SummaryEU__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ShareResults__ = __webpack_require__(133);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'abstract',
  routes: [{
    path: '/',
    name: 'Intro',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Intro__["a" /* default */]
  }, {
    path: '/quiz',
    name: 'Quiz',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Quest__["a" /* default */]
  }, {
    path: '/results',
    name: 'Results',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Results__["a" /* default */]
  }, {
    path: '/answers-review',
    name: 'AnswersReview',
    component: __WEBPACK_IMPORTED_MODULE_5__components_AnswersReview__["a" /* default */]
  }, {
    path: '/summary',
    name: 'Summary',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Summary__["a" /* default */]
  }, {
    path: '/unicef',
    name: 'Unicef',
    component: __WEBPACK_IMPORTED_MODULE_7__components_SummaryUnicef__["a" /* default */]
  }, {
    path: '/eu',
    name: 'EU',
    component: __WEBPACK_IMPORTED_MODULE_8__components_SummaryEU__["a" /* default */]
  }, {
    path: '/share-results',
    name: 'ShareResults',
    component: __WEBPACK_IMPORTED_MODULE_9__components_ShareResults__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  var fakePath = '/#' + to.path;
  // eslint-disable-next-line no-undef
  gtag('event', 'page_view', {
    page_title: to.name,
    page_path: fakePath
  });

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33f56fa6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__ = __webpack_require__(103);
function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33f56fa6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33f56fa6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseQuery;
var decode = decodeURIComponent;

// Copied from vue-router utils
function parseQuery(query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res;
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"intro"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 1),expression:"page === 1"}]},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("\n      Dowiedz się, czym są fake newsy, i jak je rozpoznawać.\n      Poznaj kilka prostych wskazówek, dzięki którym odnajdziesz się w świecie\n      powszechnej dezinformacji i bez problemu poradzisz sobie z naszą grą.\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 2),expression:"page === 2"}]},[_vm._m(2),_vm._v(" "),_c('h1',[_vm._v("\n      Fake news, czyli co?\n    ")]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 3),expression:"page === 3"}]},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 4),expression:"page === 4"}]},[_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 5),expression:"page === 5"}]},[_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 6),expression:"page === 6"}]},[_c('div',{attrs:{"id":"category-selection"}},[_c('h1',[_vm._v("Wybierz ulubioną tematykę treści, które pokażą się w quizie")]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"all","type":"radio","value":"all"},domProps:{"checked":_vm._q(_vm.userInfo.category,"all")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "all")}}}),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"entertainment","type":"radio","value":"entertainment"},domProps:{"checked":_vm._q(_vm.userInfo.category,"entertainment")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "entertainment")}}}),_vm._v(" "),_vm._m(14)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"nauka","type":"radio","value":"science"},domProps:{"checked":_vm._q(_vm.userInfo.category,"science")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "science")}}}),_vm._v(" "),_vm._m(15)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"ue","type":"radio","value":"ue"},domProps:{"checked":_vm._q(_vm.userInfo.category,"ue")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "ue")}}}),_vm._v(" "),_vm._m(16)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"ue2","type":"radio","value":"ue2"},domProps:{"checked":_vm._q(_vm.userInfo.category,"ue2")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "ue2")}}}),_vm._v(" "),_vm._m(17)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"climate","type":"radio","value":"climate"},domProps:{"checked":_vm._q(_vm.userInfo.category,"climate")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "climate")}}}),_vm._v(" "),_vm._m(18)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"health","type":"radio","value":"health"},domProps:{"checked":_vm._q(_vm.userInfo.category,"health")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "health")}}}),_vm._v(" "),_vm._m(19)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"society","type":"radio","value":"society"},domProps:{"checked":_vm._q(_vm.userInfo.category,"society")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "society")}}}),_vm._v(" "),_vm._m(20)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 7 && _vm.userInfo.category === 'ue'),expression:"page === 7 && userInfo.category === 'ue'"}]},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("\n      Partner kategorii\n    ")]),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n      Projekt Przedstawicielstwa Komisji Europejskiej w Polsce oraz Biura\n      Parlamentu Europejskiego w Polsce realizowany przez Stowarzyszenie Demagog.\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 7 && _vm.userInfo.category === 'ue2'),expression:"page === 7 && userInfo.category === 'ue2'"}]},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("\n      INFORMACJE O KATEGORII\n    ")]),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n      Nowa kategoria Fajnie, że wiesz powstała w ramach projektu Stowarzyszenia Demagog pt.\n      „Fakty, nie fikcja! Kampania antydezinformacyjna na temat praw i wartości Unii Europejskiej\n      skierowana do nauczycieli w małych miejscowościach i na obszarach wiejskich”.\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 7 && (_vm.userInfo.category === 'climate' || _vm.userInfo.category === 'health' || _vm.userInfo.category === 'society')),expression:"page === 7 && (userInfo.category === 'climate' || userInfo.category === 'health' || userInfo.category === 'society')"}]},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("\n      INFORMACJE O KATEGORII\n    ")]),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 8),expression:"page === 8"}]},[_vm._m(25),_vm._v(" "),_c('h1',[_vm._v("Jesteśmy prawie gotowi!")]),_vm._v(" "),_c('p',[_vm._v("\n      Czeka na Ciebie quiz z "+_vm._s(_vm.numOfQuizQuestions)+" przykładami treści,\n      które zostały opublikowane w sieci.\n      "),_c('b',[_vm._v("\n        Kieruj się intuicją i zdecyduj, które z nich są fake newsami,\n        poprzez klikanie na przyciski „Fake” i „Prawda”.\n      ")]),_vm._v("\n      Na każdy przykład masz "+_vm._s(_vm.questionTimeoutInSeconds)+" sekund.\n      Po upływie czasu przykład się zmieni. To jak, zaczynamy?\n    ")])]),_vm._v(" "),_c('button',{class:_vm.incrementPageButtonClass,attrs:{"disabled":_vm.incrementPageDisabled},on:{"click":_vm.incrementPage}},[_vm._v("\n    "+_vm._s(_vm.incrementPageButtonText)+"\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/hello.png","alt":"hello"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      Cześć!"),_c('br'),_vm._v("\n      Fajnie, że jesteś :)\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/fake_news.png","alt":"fake news"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("\n        Fake news to fałszywa informacja udostępniona w sieci lub za pośrednictwem mediów\n        tradycyjnych, imitująca informację prawdziwą.\n      ")]),_vm._v("\n      Została stworzona dla realizacji konkretnego\n      celu finansowego, politycznego lub dla prestiżu.\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/source.png","alt":"source"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      Po pierwsze - "),_c('br'),_vm._v("\n      Sprawdzaj źródła\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      Przeglądając wpisy i artykuły w mediach społecznościowych, zawsze zwracaj uwagę na źródło.\n      Fałszywe strony często podszywają się\n      pod wiarygodne źródła lub mają charakter satyryczny.\n      "),_c('b',[_vm._v("Przyglądaj się nazwie oraz logotypowi strony.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/graphics.png","alt":"graphics"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      Po drugie - "),_c('br'),_vm._v("\n      Przyjrzyj się grafice\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      Zdjęcie umieszczone w artykule lub mem również mogą być fake newsem. Zanim uznasz grafikę\n      za prawdziwą i podasz dalej,\n      "),_c('b',[_vm._v("\n        zastanów się, czy jest wykorzystana w odpowiednim kontekście,\n        czy cytat na grafice rzeczywiście jest prawdziwy.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/emotions.png","alt":"emotions"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      Po trzecie - "),_c('br'),_vm._v("\n      Czytaj, nie klikaj!\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      Celem rozpowszechniania fałszywych informacji jest wywołanie w Tobie skrajnych emocji,\n      a następnie zachęcenie Cię do kliknięcia w link czy wpis. Po co? Aby na Tobie zarobić!\n      "),_c('b',[_vm._v("\n        Zwracaj uwagę na wpisy skrajnie emocjonalne, liczne wykrzykniki czy duże litery w tytule.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"all"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/world.svg","alt":""}})]),_c('div',[_vm._v("Wiedza ogólna")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"entertainment"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/fireworks.svg","alt":""}})]),_c('div',[_vm._v("Rozrywka")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"nauka"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/atom.svg","alt":""}})]),_c('div',[_vm._v("Nauka")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"ue"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/ue.svg","alt":""}})]),_c('div',[_vm._v("Unia Europejska")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"ue2"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/values.png","alt":""}})]),_c('div',[_vm._v("Prawa i wartości UE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"climate"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/klimat5.svg","alt":""}})]),_c('div',[_vm._v("Klimat")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"health"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/zdrowie1.svg","alt":""}})]),_c('div',[_vm._v("Zdrowie")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"society"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/society1.svg","alt":""}})]),_c('div',[_vm._v("Społeczeństwo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"340px","max-width":"100%","mix-blend-mode":"multiply","margin":"0 auto","display":"block"},attrs:{"src":"static/img/parlament.png","alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"200px","max-width":"100%","margin":"-20px auto 40px","display":"block"},attrs:{"src":"static/img/komisja.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"340px","max-width":"100%","mix-blend-mode":"multiply","margin":"10px auto","display":"block"},attrs:{"src":"static/img/eu2.png","alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"340px","max-width":"100%","margin":"20px auto 40px","display":"block"},attrs:{"src":"static/img/gmf.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"340px","max-width":"100%","mix-blend-mode":"multiply","margin":"10px auto","display":"block"},attrs:{"src":"static/img/demagog.png","alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"340px","max-width":"100%","margin":"20px auto 40px","display":"block"},attrs:{"src":"static/img/01_znak_podstawowy_kolor_biale_tlo.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n      Nowa kategoria Fajnie, że wiesz powstała w ramach projektu Stowarzyszenia Demagog pt. Fakty w zasięgu ręki. Program wzmacniania społecznej odporności na dezinformację w obszarze klimatu, zdrowia i spraw społecznych dla uczniów, studentów, nauczycieli i rodziców. "),_c('br'),_c('br'),_vm._v("\n      Zadanie finansowane ze środków Ministerstwa Cyfryzacji.\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/lets_begin.png","alt":"let's begin"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quest_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41d5edcf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quest_vue__ = __webpack_require__(111);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41d5edcf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41d5edcf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbbbe8f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieChart_vue__ = __webpack_require__(108);
function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bbbbe8f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbbbe8f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('text',{style:({ fill: 'white'}),attrs:{"x":"25","y":25,"font-size":_vm.textPercent ? 13 : 17}},[_vm._v("\n      "+_vm._s(_vm.counterText)+"\n    ")]),_vm._v(" "),_c('polyline',{style:({ stroke: '#ddd', opacity: '15%' }),attrs:{"points":_vm.points.t}}),_vm._v(" "),_c('polyline',{style:({ stroke: '#EF420C'}),attrs:{"points":_vm.points.s}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:['card', 'img', _vm.answerClass],attrs:{"src":_vm.question.imageUrl,"alt":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",staticStyle:{"overflow":"hidden","background-image":"url('static/img/question-bg.png')"},attrs:{"id":"quest"}},[_c('PieChart',{attrs:{"id":"counter","numerator":_vm.countdownSeconds,"denominator":_vm.questionTimeoutSeconds,"text-percent":false}}),_vm._v(" "),_c('ul',{staticClass:"progress"},_vm._l((_vm.questions),function(q,index){return _c('li',{key:q.newsId,class:{ active: index === _vm.questionIndex }})})),_vm._v(" "),_vm._l((_vm.questions),function(q,index){return _c('transition',{key:q.newsId,attrs:{"name":"question-transition"},on:{"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_c('QuestCard',{directives:[{name:"show",rawName:"v-show",value:(index === _vm.questionIndex),expression:"index === questionIndex"}],attrs:{"question":q}})],1)}),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"opaque-white answer",attrs:{"disabled":_vm.buttonsDisabled},on:{"click":function($event){_vm.answerFalseNews()}}},[_vm._v("\n      Fake\n    ")]),_vm._v(" "),_c('button',{staticClass:"opaque-white answer",attrs:{"disabled":_vm.buttonsDisabled},on:{"click":function($event){_vm.answerTrueNews()}}},[_vm._v("\n      Prawda\n    ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa38f87_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__ = __webpack_require__(117);
function injectStyle (ssrContext) {
  __webpack_require__(113)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1aa38f87"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa38f87_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countByPredicate; });
var countByPredicate = function countByPredicate(arr, predicate) {
  return arr.reduce(function (acc, v) {
    return predicate(v) ? acc + 1 : acc;
  }, 0);
};

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"results"}},[_c('div',{},[_vm._m(0),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v("\n      "+_vm._s(_vm.numOfCorrectAnswers)+" z "+_vm._s(_vm.numOfQuestions)+" prawidłowych odpowiedzi\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")])]),_vm._v(" "),_c('router-link',{staticClass:"opaque-white",attrs:{"tag":"button","type":"button","name":"button","to":"/answers-review"}},[_vm._v("\n    Sprawdź odpowiedzi\n  ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/results.png","alt":"source"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswersReview_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90e9364a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswersReview_vue__ = __webpack_require__(123);
function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90e9364a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswersReview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90e9364a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswersReview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FootLinkNote_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af467e10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FootLinkNote_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(121)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af467e10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FootLinkNote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af467e10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FootLinkNote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkNameText)?_c('p',{staticClass:"foot-link-note"},[_vm._v("\n  "+_vm._s(_vm.name)+":\n  "),(_vm.linkUrl)?_c('span',[_c('a',{attrs:{"href":_vm.linkUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.linkNameText))])]):_c('span',[_vm._v("\n    "+_vm._s(_vm.linkNameText)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"app-container",attrs:{"id":"answers-review"},on:{"scroll":_vm.updateScrollData}},[_c('div',{staticClass:"content-container"},[_c('ul',{staticClass:"progress"},_vm._l((_vm.questions),function(q,index){return _c('li',{key:q.newsId,class:{ active: index === _vm.questionIndex }})})),_vm._v(" "),_c('h1',{domProps:{"textContent":_vm._s(_vm.answerType.text)}}),_vm._v(" "),_c('quest-card',{attrs:{"question":_vm.question}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.question.answerExplanationHTML)}}),_vm._v(" "),_c('div',{staticClass:"foot-link-notes"},[_c('foot-link-note',{attrs:{"name":"Źrodło","link-name":_vm.sourceName,"link-url":_vm.sourceUrl}}),_vm._v(" "),_c('foot-link-note',{attrs:{"name":"Analiza","link-name":_vm.analysisName,"link-url":_vm.analysisUrl}})],1),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"opaque-blue",attrs:{"disabled":!_vm.nextAnswerEnabled,"type":"button","name":"button"},on:{"click":function($event){_vm.goToNextAnswer()}}},[_vm._v("\n        "+_vm._s(_vm.nextAnswerText)+"\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cbb0e9f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__(126);
function injectStyle (ssrContext) {
  __webpack_require__(125)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cbb0e9f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cbb0e9f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"summary"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('router-link',{staticClass:"opaque-blue",attrs:{"tag":"button","type":"button","name":"button","to":"/share-results"}},[_vm._v("\n      Dalej\n    ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Fajnie, że wiesz!")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n        Mamy nadzieję, że teraz już wiesz, jak rozpoznawać fake newsy.\n        Czytając informacje w internecie, pamiętaj o najważniejszych zasadach!\n      ")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n        Zwracaj uwagę na podejrzane i nieznane źródło informacji.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Pamiętaj, że zdjęcie umieszczone w artykule lub mem również może być fake newsem.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Zwracaj uwagę na wpisy skrajnie emocjonalne, liczne wykrzykniki,\n        pytajniki czy duże litery.\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryUnicef_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b7b2af2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryUnicef_vue__ = __webpack_require__(129);
function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b7b2af2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryUnicef_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b7b2af2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryUnicef_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"unicef"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"buttons-row"},[_vm._m(1),_vm._v(" "),_c('router-link',{staticClass:"opaque-blue",attrs:{"tag":"button","type":"button","name":"button","to":"/share-results"}},[_vm._v("\n      Dalej\n    ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("\n      Podpisz apel UNICEF Polska do Ministra Zdrowia\n      i pomóż chronić dzieci przed groźnymi chorobami zakaźnymi!\n    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n        UNICEF Polska apeluje o:\n      ")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n        wspieranie rodziców w dostępie do wiarygodnych informacji na temat szczepień,\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        walkę z dezinformacją w mediach i przekłamywaniem informacji na temat szczepień,\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        aktywną promocję Programu Szczepień Ochronnych.\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"targt":"_blank","href":"https://unicef.pl/chce-pomoc/podpisz-apel/spadek-liczby-szczepien?utm_source=Demagog&utm_medium=quiz&utm_campaign=apel_szczepienia"}},[_c('button',{staticClass:"opaque-blue",attrs:{"type":"button","name":"button"}},[_vm._v("Podpisz apel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryEU_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b19d72dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryEU_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b19d72dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryEU_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b19d72dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryEU_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"eu"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"buttons-row"},[_c('router-link',{staticClass:"opaque-blue",attrs:{"tag":"button","type":"button","name":"button","to":"/share-results"}},[_vm._v("\n      Dalej\n    ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("\n      INFORMACJE O KATEGORII\n    ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"2vh","line-height":"1.5","margin-top":"20px"}},[_vm._v("\n      Projekt jest finansowany w ramach programu „Protecting EU Values and Fundamental Rights\n      through Public Participation and Civil Society Assistance in Central Europe – PROTEUS”\n      realizowanego przez TF we współpracy z programem Engaging Central Europe (ECE) of The\n      German Marshall Fund of the United States. Program PROTEUS jest współfinansowany przez\n      Europejską Agencję Wykonawczą ds. Edukacji i Kultury (EACEA) w ramach europejskiego\n      programu „Obywatele, równość, prawa i wartości” (CERV).\n    ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"2vh","line-height":"1.5"}},[_vm._v("\n      Przedstawione poglądy i opinie są wyłącznie poglądami autora (autorów) i nie muszą\n      odzwierciedlać poglądów Unii Europejskiej ani Europejskiej Agencji Wykonawczej ds.\n      Edukacji i Kultury (EACEA). Unia Europejska ani organ przyznający dotację nie\n      ponoszą za nie odpowiedzialności.\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareResults_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a435f1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareResults_vue__ = __webpack_require__(135);
function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57a435f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a435f1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"share-results"}},[_c('div',[_c('h1',[_vm._v("Dzięki za wspólny czas")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"share-button",attrs:{"type":"button","name":"share-results"},on:{"click":function($event){_vm.shareResults()}}},[_c('img',{attrs:{"src":"static/img/fb.svg","alt":""}}),_vm._v(" "),_c('span',[_vm._v("Udostępnij")])]),_vm._v(" "),_c('div',{staticClass:"rating",class:{ rated: _vm.rated }},[_c('div',{staticClass:"rating-group"},[_vm._l((5),function(index){return [_c('label',{key:'label-'+index,staticClass:"rating__label",attrs:{"for":'rating-'+index}},[_c('div',{staticClass:"rating__icon rating__icon--star"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"48.863","height":"46.513","viewBox":"0 0 48.863 46.513"}},[_c('path',{attrs:{"data-name":"Path 224","d":"M48.824 17.687a.788.788 0 00-.637-.537l-15.926-2.314L25.141.404a.82.82 0 00-1.413 0l-7.127 14.432L.675 17.151a.788.788 0 00-.438 1.344L11.764 29.73l-2.72 15.863a.788.788 0 001.143.831l14.244-7.49 14.245 7.487a.788.788 0 001.143-.831l-2.718-15.86 11.525-11.235a.788.788 0 00.198-.808z","fill":"#dee6ea"}})])])]),_vm._v(" "),_c('input',{key:'input-'+index,staticClass:"rating__input",attrs:{"id":'rating-'+index,"name":"rating","type":"radio"},domProps:{"value":index,"checked":index == 5}})]})],2)]),_vm._v(" "),(!_vm.rated)?_c('button',{staticClass:"opaque-blue",attrs:{"type":"button","name":"button"},on:{"click":function($event){_vm.sendRate()}}},[_vm._v("\n      Prześlij ocenę\n    ")]):_vm._e(),_vm._v(" "),(_vm.rated)?_c('p',[_vm._v("\n      Dziękujemy za ocenę!\n    ")]):_vm._e()]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Będziemy wdzięczni, jeżeli udostępnisz informacje o naszej grze na Facebooku, oraz ocenisz ją gwiazdkami, tak jak uważasz za słuszne. :)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons"},[_c('h3',[_vm._v("\n      Chcesz więcej?\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Dowiedz się więcej o tym, jak powstają fake newsy, lub zagraj jeszcze raz!\n    ")]),_vm._v(" "),_c('div',{staticClass:"buttons-row"},[_c('a',{attrs:{"href":"/"}},[_c('button',{staticClass:"opaque-blue",attrs:{"type":"button","name":"button"}},[_vm._v("zagraj")])]),_vm._v(" "),_c('a',{attrs:{"href":"https://demagog.org.pl","target":"_blank"}},[_c('button',{staticClass:"opaque-blue",attrs:{"type":"button","name":"button"}},[_vm._v("Chcę więcej")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_quizes__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ping__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_manipulation_category__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_manipulation_category__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_quiz__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_quiz_setup_info__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_user__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_result_stats__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_topic_category__ = __webpack_require__(79);
















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    quiz: __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].create({ id: null }),
    user: __WEBPACK_IMPORTED_MODULE_11__data_user__["a" /* default */].create({ name: 'test' }),
    quizSetupInfo: __WEBPACK_IMPORTED_MODULE_10__data_quiz_setup_info__["a" /* default */].create({}),
    manipulationCategories: []
  },
  actions: {
    fetchManipulationCategories: function fetchManipulationCategories(context) {
      __WEBPACK_IMPORTED_MODULE_7__services_manipulation_category__["a" /* default */].fetchList().then(function (manipulationCategories) {
        context.commit('loadManipulationCategories', { manipulationCategories: manipulationCategories });
      });
    },
    generateQuiz: function generateQuiz(context) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var language, topicCategory, quiz, images;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                language = __WEBPACK_IMPORTED_MODULE_4__consts__["b" /* QUESTION_LANGUAGE */];
                topicCategory = __WEBPACK_IMPORTED_MODULE_10__data_quiz_setup_info__["a" /* default */].getTopicCategory(context.state.quizSetupInfo);
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_quizes__["a" /* generateQuiz */])({ topicCategory: topicCategory, language: language });

              case 4:
                quiz = _context.sent;
                _context.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_quizes__["b" /* loadQuizImages */])(quiz);

              case 7:
                images = _context.sent;

                context.commit('loadQuiz', {
                  quiz: quiz, images: images
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    pingBackend: function pingBackend() {
      Object(__WEBPACK_IMPORTED_MODULE_6__services_ping__["a" /* ping */])();
    }
  },
  mutations: {
    loadQuiz: function loadQuiz(state, _ref) {
      var quiz = _ref.quiz;

      state.quiz = quiz;
    },
    loadManipulationCategories: function loadManipulationCategories(state, _ref2) {
      var manipulationCategories = _ref2.manipulationCategories;

      state.manipulationCategories = manipulationCategories;
    },
    answerQuizQuestion: function answerQuizQuestion(state, _ref3) {
      var answer = _ref3.answer;

      __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].answerQuestion(state.quiz, answer);
    },
    omitQuizQuestion: function omitQuizQuestion(state) {
      __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].omitQuestion(state.quiz);
    },
    setUserInfo: function setUserInfo(state, userInfo) {
      __WEBPACK_IMPORTED_MODULE_11__data_user__["a" /* default */].setName(state.user, userInfo.name);
      var topicCategory = null;
      if (userInfo.category && userInfo.category !== 'all') {
        topicCategory = __WEBPACK_IMPORTED_MODULE_13__data_topic_category__["a" /* default */].fromName(userInfo.category);
      }
      __WEBPACK_IMPORTED_MODULE_10__data_quiz_setup_info__["a" /* default */].setValues(state.quizSetupInfo, {
        topicCategory: topicCategory,
        correctnessEstimate: userInfo.prediction / 100
      });
    }
  },
  getters: {
    isQuizLoaded: function isQuizLoaded(state) {
      return !!__WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getId(state.quiz);
    },
    manipulationCategories: function manipulationCategories(state) {
      return state.manipulationCategories;
    },
    manipulationCategoriesMap: function manipulationCategoriesMap(state) {
      return __WEBPACK_IMPORTED_MODULE_8__data_manipulation_category__["a" /* default */].mapFromList(state.manipulationCategories);
    },
    currentQuizQuestion: function currentQuizQuestion(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getCurrentQuestion(state.quiz);
    },
    quizQuestions: function quizQuestions(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getQuestions(state.quiz);
    },
    quizQuestionIndex: function quizQuestionIndex(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getQuestionIndex(state.quiz);
    },
    numOfQuizQuestions: function numOfQuizQuestions(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getQuestions(state.quiz).length;
    },
    isQuizFinished: function isQuizFinished(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].isFinished(state.quiz);
    },
    resultStats: function resultStats(state) {
      var quiz = state.quiz,
          user = state.user,
          quizSetupInfo = state.quizSetupInfo,
          manipulationCategories = state.manipulationCategories;

      return __WEBPACK_IMPORTED_MODULE_12__data_result_stats__["a" /* default */].create({
        quiz: quiz,
        user: user,
        quizSetupInfo: quizSetupInfo,
        manipulationCategories: manipulationCategories
      });
    }
  }
}));

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateQuiz; });
/* harmony export (immutable) */ __webpack_exports__["b"] = loadQuizImages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_quiz__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_topic_category__ = __webpack_require__(79);









function parseQuestion(data) {
  return __WEBPACK_IMPORTED_MODULE_5__data_question__["a" /* default */].create({
    newsId: data.news_id,
    imageUrl: data.image_url,
    sourceName: data.source_name,
    sourceUrl: data.source_url,
    analysisName: data.analysis_name,
    analysisUrl: data.analysis_url,
    type: data.manipulation_category_name,
    answerExplanationHTML: data.answer_explanation_html,
    expectedAnswer: data.expected_answer
  });
}

function parseQuiz(data) {
  return __WEBPACK_IMPORTED_MODULE_4__data_quiz__["a" /* default */].create({
    id: data.id,
    questions: (data.questions || []).map(parseQuestion)
  });
}

var generateQuiz = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var _ref2$topicCategory = _ref2.topicCategory,
        topicCategory = _ref2$topicCategory === undefined ? null : _ref2$topicCategory,
        _ref2$language = _ref2.language,
        language = _ref2$language === undefined ? null : _ref2$language;
    var data, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = {};

            if (Object({"NODE_ENV":"production","BUILD_ENV":"production","GOOGLE_ANALYTICS_TRACKER_ID":"UA-156092120-1","BACKEND_HOST":"backend.fakesnothanks.pl","BACKEND_HTTP_SCHEME":"https","APP_HOST":"aplikacja.fajniezewiesz.pl","APP_HTTP_SCHEME":"https"}).NUM_OF_QUIZ_QUESTIONS) {
              data['num_of_questions'] = Object({"NODE_ENV":"production","BUILD_ENV":"production","GOOGLE_ANALYTICS_TRACKER_ID":"UA-156092120-1","BACKEND_HOST":"backend.fakesnothanks.pl","BACKEND_HTTP_SCHEME":"https","APP_HOST":"aplikacja.fajniezewiesz.pl","APP_HTTP_SCHEME":"https"}).NUM_OF_QUIZ_QUESTIONS;
            }
            if (topicCategory) {
              data['topic_category_name'] = __WEBPACK_IMPORTED_MODULE_6__data_topic_category__["a" /* default */].getName(topicCategory);
            }
            if (language) {
              data['language'] = language;
            }
            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].post('quiz/', data);

          case 6:
            response = _context.sent;
            return _context.abrupt('return', parseQuiz(response.data));

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function generateQuiz(_x) {
    return _ref.apply(this, arguments);
  };
}();

function loadImageByUrl(url) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      return resolve(img);
    };
    img.onerror = function () {
      return reject(new Error('Image ' + url + ' could not be loaded'));
    };
    img.src = url;
  });
}

function loadQuizImages(quiz) {
  var questions = __WEBPACK_IMPORTED_MODULE_4__data_quiz__["a" /* default */].getQuestions(quiz);
  var imageUrls = questions.map(__WEBPACK_IMPORTED_MODULE_5__data_question__["a" /* default */].getImageUrl);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(imageUrls.map(loadImageByUrl));
}

/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.2","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(68);


function ping() {
  return __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */].get('ping/').then(function (response) {
    return response.data.message;
  });
}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__ = __webpack_require__(17);



function fetchList() {
  // TODO: move to external REST API
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    resolve([__WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].create({
      name: 'clickbait'
    }), __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].create({
      name: 'fake-news'
    }), __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].create({
      name: 'image-manipulation'
    }), __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].create({
      name: 'emotional-language'
    })]);
  });
}

function fetchMap() {
  return fetchList().then(function (categories) {
    return __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].mapFromList(categories);
  });
}

var ManipulationCategoryService = {
  fetchList: fetchList,
  fetchMap: fetchMap
};

/* harmony default export */ __webpack_exports__["a"] = (ManipulationCategoryService);

/***/ })
],[80]);


// WEBPACK FOOTER //
// static/js/app.00b9ee322e5a9107dc35.js